import React, { useState } from 'react';
import { Form, Card, Button, Modal, Alert, Row, Col } from 'react-bootstrap';

const AddBookPenaltyForm = () => {
  const [formData, setFormData] = useState({
    book: '',
    user: '',
    amount: '',
    type: '',
    reissue: false
  });

  const [errors, setErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const validateForm = () => {
    let formErrors = {};
    ['book', 'user', 'amount', 'type'].forEach((field) => {
      if (!formData[field]) {
        formErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
      }
    });
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setTimeout(() => {
        const isSuccess = Math.random() > 0.5;
        if (isSuccess) {
          setShowSuccessModal(true);
        } else {
          setShowErrorModal(true);
        }
      }, 1000);
    }
  };

  return (
    <Card
      className="shadow-sm rounded-lg mx-auto p-4 d-flex flex-column justify-content-between"
      style={{ maxWidth: '850px', width: '100%', height: '550px' }}
    >
      <div>
        <h5 className="text-center mb-4">Book Penalty</h5>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="book">
            <Form.Label>Book</Form.Label>
            <Form.Control
              as="select"
              name="book"
              value={formData.book}
              onChange={handleInputChange}
              isInvalid={!!errors.book}
            >
              <option value="">Select Book</option>
              <option value="Book 1">Book 1</option>
              <option value="Book 2">Book 2</option>
              <option value="Book 3">Book 3</option>
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.book}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="user">
            <Form.Label>User</Form.Label>
            <Form.Control
              as="select"
              name="user"
              value={formData.user}
              onChange={handleInputChange}
              isInvalid={!!errors.user}
            >
              <option value="">Select User</option>
              <option value="User 1">User 1</option>
              <option value="User 2">User 2</option>
              <option value="User 3">User 3</option>
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.user}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="amount">
            <Form.Label>Amount</Form.Label>
            <Form.Control
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleInputChange}
              isInvalid={!!errors.amount}
              placeholder="Enter penalty amount"
            />
            <Form.Control.Feedback type="invalid">
              {errors.amount}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="type">
            <Form.Label>Type</Form.Label>
            <Form.Control
              as="select"
              name="type"
              value={formData.type}
              onChange={handleInputChange}
              isInvalid={!!errors.type}
            >
              <option value="">Select Type</option>
              <option value="Late Return">Late Return</option>
              <option value="Damage">Damage</option>
              <option value="Lost">Lost</option>
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.type}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="reissue" className='mt-3'>
            <Form.Check
              type="checkbox"
              name="reissue"
              label="Re-issue"
              checked={formData.reissue}
              onChange={handleInputChange}
            />
          </Form.Group>
        </Form>
      </div>

      <div className="d-flex justify-content-between mt-3">
        <Button variant="primary" type="submit" onClick={handleSubmit}>
          Submit
        </Button>
        <Button variant="secondary" type="button">
          Cancel
        </Button>
      </div>

      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
        <Modal.Body>
          <Alert variant="success">Form submitted successfully!</Alert>
        </Modal.Body>
        <Button variant="secondary" onClick={() => setShowSuccessModal(false)}>
          Close
        </Button>
      </Modal>

      <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered>
        <Modal.Body>
          <Alert variant="danger">Failed to submit form. Please try again.</Alert>
        </Modal.Body>
        <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
          Close
        </Button>
      </Modal>
    </Card>
  );
};

export default AddBookPenaltyForm;
